import { useModal } from "react-modal-hook";
import MessageModal from "../ui/design-system/MessageModalSync";

type ConfirmProps = {
  title: string;
  message: string | JSX.Element;
  agree?: string;
  disagree?: string;
  onAgree?: () => unknown;
  onDisagree?: () => unknown;
  onClose?: () => unknown;
  hide?: () => unknown;
  noDisagree?: boolean;
  canBeClosed?: boolean;
  zIndex?: number;
  successMessage?: string;
};

export const useConfirmModal = ({
  title,
  message,
  agree,
  disagree,
  onAgree,
  onDisagree,
  onClose,
  noDisagree = false,
  canBeClosed = true,
  zIndex,
  successMessage,
}: ConfirmProps) => {
  const [show, hide] = useModal(
    () => (
      <MessageModal
        title={title}
        onAgree={onAgree}
        onCancel={onDisagree}
        onClose={onClose}
        agree={agree}
        cancel={disagree}
        hideModal={hide}
        size={"small"}
        noCancel={noDisagree}
        canBeClosed={canBeClosed}
        zIndex={zIndex}
        successMessage={successMessage}
      >
        {message}
      </MessageModal>
    ),
    [message, onAgree]
  );
  return { show, hide };
};
